"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzCheck = _interopRequireDefault(require("./../OzCheck/OzCheck.js"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Table = _styledComponents.default.table.withConfig({
  displayName: "OzTable__Table",
  componentId: "sc-jz6ejk-0"
})(["\n  width: 100%;\n  border-collapse: collapse;\n  border: 0px;\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var THead = _styledComponents.default.thead.withConfig({
  displayName: "OzTable__THead",
  componentId: "sc-jz6ejk-1"
})(["\n  & tr{\n    border-bottom: 1px solid #707070;\n    /*\n    box-shadow: 0px 2px 10px #C1CCE838;\n    z-index: 2;\n    position: relative; */\n  }\n  & tr th{\n    padding: 15px 10px 15px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #303030;\n  }\n"]);

var TBody = _styledComponents.default.tbody.withConfig({
  displayName: "OzTable__TBody",
  componentId: "sc-jz6ejk-2"
})(["\n  & tr:nth-child(odd){\n    background-color: ", ";\n    border-left: 1px solid ", ";\n    border-right: 1px solid ", ";\n    /*z-index: 1;\n    position: relative;*/\n  }\n  & tr td{\n    border-bottom: 1px dashed #70707029;\n  }\n  & tr:nth-child(odd) td{\n    border-bottom: 1px dashed #50505029;\n  }\n  & tr td a{\n    text-decoration: none;\n    color: inherit;\n    display: block;\n  }\n"], _consts.GHOSTWHITE, _consts.GHOSTWHITE, _consts.GHOSTWHITE);

var Row = _styledComponents.default.tr.withConfig({
  displayName: "OzTable__Row",
  componentId: "sc-jz6ejk-3"
})(["\n  ", "\n\n  & td{\n    ", "\n  }\n\n  &:hover td{\n    background-color: ", ";\n  }\n"], function (props) {
  return props.background ? "background-color: " + props.background + " !important;" : null;
}, function (props) {
  return props.color ? "color: " + props.color + ";" : null;
}, function (props) {
  return props.backgroundHover ? props.backgroundHover : _consts.LILAC;
});

var Cell = _styledComponents.default.div.withConfig({
  displayName: "OzTable__Cell",
  componentId: "sc-jz6ejk-4"
})(["\n  font-size: 12px;\n  padding: 15px 10px 15px 10px;\n"]);

var OzTable = function OzTable(_ref) {
  var columns = _ref.columns,
      values = _ref.values,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? [] : _ref$selected,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect;
  return __jsx(Table, null, __jsx(THead, null, __jsx("tr", null, selectable ? __jsx("th", {
    width: "20px"
  }, __jsx(_OzCheck.default, {
    selected: values.map(function (row) {
      return row.id;
    }).every(function (v) {
      return selected.includes(v);
    }),
    onChange: function onChange() {
      if (values.map(function (row) {
        return row.id;
      }).every(function (v) {
        return selected.includes(v);
      })) {
        onSelect(values.map(function (row) {
          return row.id;
        }));
      } else {
        onSelect(values.map(function (row) {
          return !selected.includes(row.id) ? row.id : null;
        }));
      }
    }
  })) : null, columns.map(function (item, i) {
    return __jsx("th", {
      key: i
    }, item);
  }))), __jsx(TBody, null, values.map(function (row, i) {
    var Link = row.link;
    return __jsx(Row, {
      key: i,
      background: row.style && row.style.background ? row.style.background : null,
      backgroundHover: row.style && row.style.backgroundHover ? row.style.backgroundHover : null,
      color: row.style && row.style.color ? row.style.color : null
    }, selectable ? __jsx("td", {
      width: "20px"
    }, __jsx(Cell, null, __jsx(_OzCheck.default, {
      selected: selected.includes(row.id),
      onChange: function onChange() {
        return onSelect([row.id]);
      }
    }))) : null, row.values.map(function (item, j) {
      return __jsx("td", {
        key: j
      }, Link ? __jsx(Link, null, __jsx(Cell, null, item)) : __jsx(Cell, null, item));
    }));
  })));
};

var _default = OzTable;
exports.default = _default;